import { ISidebarConfig, UserRole } from './sidebar-menu.interface';
import { GUARD_SIDEBAR_CONFIG } from '../../configs/guard.config';
import { HR_SIDEBAR_CONFIG } from '../../configs/hr.config';
import { SUPERVISOR_SIDEBAR_CONFIG } from '../../configs/supervisor.config';
import { SYSTEM_ADMIN_SIDEBAR_CONFIG } from '../../configs/system-admin.config';
import { ADMIN_SIDEBAR_CONFIG } from '../../configs/admin.config';
import { OTHERS_SIDEBAR_CONFIG } from '../../configs/others.config';
import { POST_RESIDENT_SIDEBAR_CONFIG, POST_SUPERVISOR_SIDEBAR_CONFIG } from '../../configs/post-resident.config';

// Centralizando todas as configurações
export const SIDEBAR_CONFIGS: Record<UserRole, ISidebarConfig> = {
    SYSTEM_ADMIN: SYSTEM_ADMIN_SIDEBAR_CONFIG,
    GUARD: GUARD_SIDEBAR_CONFIG,
    SUPERVISOR: SUPERVISOR_SIDEBAR_CONFIG,
    ADMIN: ADMIN_SIDEBAR_CONFIG,
    RESIDENT: GUARD_SIDEBAR_CONFIG,
    HR: HR_SIDEBAR_CONFIG,
    DOORMAN: GUARD_SIDEBAR_CONFIG,
    POST_RESIDENT: POST_RESIDENT_SIDEBAR_CONFIG,
    POST_SUPERVISOR: POST_SUPERVISOR_SIDEBAR_CONFIG,
    OTHERS: OTHERS_SIDEBAR_CONFIG,
};

/**
 * Retorna a configuração do sidebar baseada no role do usuário
 */
export function getSidebarConfig(role: UserRole): ISidebarConfig {
    return SIDEBAR_CONFIGS[role] || SIDEBAR_CONFIGS.OTHERS;
}
